import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { ICryptoPortfolio } from '../../models/Crypto';
import { FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../abstraction/auth.service';
import { Observable } from 'rxjs';
import { coins_pairs } from '../../utils/coins.constants';
import { Utils } from '../../utils/Utils';
import { Router } from '@angular/router';
import { GroupsService } from '../../abstraction/groups.service';
import { IGroup, ILeaderboard, quoteCoins } from '../../models/group';
import { ErrorHandlingService } from '../../services/utils/error-handling.service';
import { Title } from '@angular/platform-browser';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.scss'],
})
export class GroupComponent implements OnInit {
  leaderboard: Observable<ILeaderboard[]>;
  positions: ICryptoPortfolio[] = [];
  coins = coins_pairs;
  historyOrders = [];
  Math = Math;
  group: Observable<IGroup>;
  tab: string = 'group';
  hasGroup: boolean = false;
  step: number = 1;
  selectAction: string = 'create';
  name: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(3),
    Validators.maxLength(15),
  ]);
  codeId: FormControl = new FormControl('', Validators.required);
  showError: boolean = false;
  availableCoins: string[] = [];
  code: string;
  loading = true;
  loadingLeaderboard = true;
  loadingHistory = true;
  disablePaginationButtons = true;
  isCopy: boolean = false;
  textButtonCopy: string = 'Código de invitación';
  quoteCoins = quoteCoins;
  pageHistory = {
    page: 1,
    limit: 10,
  };
  isMobile: boolean;
  groupName: string;
  users;
  dateClose: { close: Date; daysLeft: number; text: string } = {
    close: new Date(2023, 9, 27, 23, 59, 59, 999),
    daysLeft: null,
    text: '',
  };
  dateFinish: { close: Date; daysLeft: number; text: string } = {
    close: new Date(2023, 9, 10, 23, 59, 59, 999),
    daysLeft: null,
    text: '',
  };
  constructor(
    private dialog: MatDialog,
    public authService: AuthService,
    private clipboard: Clipboard,
    private router: Router,
    private groupsService: GroupsService,
    private errorHandlingService: ErrorHandlingService,
    private titleService: Title,
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('TiendaCrypto | Grupos');
    this.groupsService.getGroup().subscribe(
      () => {},
      () => {
        this.loading = false;
      },
    );
    this.groupsService.getLeaderboard();
    this.leaderboard = this.groupsService.leaderboard;
    this.leaderboard.subscribe((resp) => {
      if (resp) this.loadingLeaderboard = false;
    });
    this.group = this.groupsService.group;
    this.group.subscribe((resp) => {
      if (resp) {
        const positionsUpdate = [];
        this.code = resp.id;
        this.hasGroup = true;
        this.groupName = resp.name;
        this.users = resp.users;
        Object.entries(resp.balance).map((resp) => {
          if (quoteCoins[resp[0]] && resp[0] !== 'BTC' && resp[0] !== 'ETH') {
            if (parseFloat(resp[1]) >= 0.001) {
              positionsUpdate.push({
                ticker: resp[0],
                stocks: resp[1],
              });
            }
          } else {
            if (parseFloat(resp[1]) >= 0.0000001)
              positionsUpdate.push({
                ticker: resp[0],
                stocks: resp[1],
              });
          }
        });
        this.positions = positionsUpdate;
      }
    });
    this.isMobile = Utils.onMobile();
    this.setTextButton();
    this.updateDaysLeft();
  }

  makeTrade() {
    this.router.navigate(['/grupos/trade']);
  }

  create() {
    this.name.setValue(this.name.value.trim());
    if (this.name.valid) {
      this.dialog
        .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: 'Creación de grupo',
            content: `¿Estás seguro de crear el grupo “<span class="name-group">${this.name.value}</span>”?`,
            acceptLabel: 'Confirmar',
          },
        })
        .afterClosed()
        .subscribe((result) => {
          if (result === 'Confirmar') {
            this.groupsService.createGroup(this.name.value).subscribe(
              () => {
                this.hasGroup = true;
              },
              (error) => {
                this.dialog
                  .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
                    panelClass: 'modal-container',
                    data: this.errorHandlingService.handleGroupsError(error),
                  })
                  .afterClosed();
              },
            );
          }
        });
    } else {
      this.showError = true;
    }
  }

  copyCode() {
    this.clipboard.copy(this.code);
    this.isCopy = true;
    this.textButtonCopy = 'Copiado';
    setTimeout(() => {
      this.isCopy = false;
      this.setTextButton();
    }, 1500);
  }

  join() {
    this.groupsService.joinGroup(this.codeId.value).subscribe(
      () => {},
      (error) => {
        this.dialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: this.errorHandlingService.handleGroupsError(error),
          })
          .afterClosed();
      },
    );
  }

  goHistory() {
    this.tab = 'history';
    this.getHistory();
  }

  getHistory(page = 1, limit = 10) {
    this.loadingHistory = true;
    this.disablePaginationButtons = true;
    this.groupsService.getHistoryGroup(page, limit).subscribe((orders) => {
      if (orders.length > 0) {
        this.historyOrders = this.setHistoryOrders(orders);
        this.disablePaginationButtons = false;
      } else if (page > 1 && orders.length === 0) {
        page = 1;
        this.disablePaginationButtons = false;
        this.groupsService.getHistoryGroup(page, limit).subscribe((orders) => {
          this.historyOrders = this.setHistoryOrders(orders);
        });
      }
      this.loadingHistory = false;
      this.pageHistory = {
        page: page,
        limit: limit,
      };
    });
  }

  setHistoryOrders(orders): any[] {
    let newOrders = [];
    let user;
    orders.map((order) => {
      user = this.users.find((user) => user.id === order.userId);
      let coin = coins_pairs[order.coin].baseCoin;
      let quoteCoin = coins_pairs[order.coin].quoteCoin;
      newOrders.push({
        amount: order.amount,
        price: order.price,
        status: 1,
        srcCoin: order.operation === '0' ? quoteCoin : coin,
        destCoin: order.operation === '0' ? coin : quoteCoin,
        description:
          order.operation === '0'
            ? this.isMobile
              ? quoteCoin + '/' + coin
              : 'Intercambio ' + quoteCoin + ' por ' + coin
            : this.isMobile
            ? coin + '/' + quoteCoin
            : 'Intercambio ' + coin + ' por ' + quoteCoin,
        creationTime: order.creationTime,
        username: user.name,
        category: 'order',
        operation: order.operation === '0' ? 'BUY' : 'SELL',
        isGroup: true,
      });
    });
    return newOrders;
  }

  paginatorChanges(event) {
    this.getHistory(event.page, event.limit);
  }

  setTextButton() {
    if (this.isMobile) this.textButtonCopy = 'Invitación';
    else this.textButtonCopy = 'Código de invitación';
  }

  onKeyDown(event: KeyboardEvent) {
    const specialChars = /[¡!°@#$%^&*()_+\-=[\]{};':"\\|,.<>/¿?]+/;
    if (specialChars.test(event.key) && this.selectAction === 'create') {
      event.preventDefault();
    }
  }

  limitChars() {
    if (this.name.value.length > '15') {
      this.name.setValue(this.name.value.substr(0, 15));
    }
  }

  updateDaysLeft() {
    const currentDay = new Date();
    const differ = this.dateClose.close.getTime() - currentDay.getTime();
    const differFinish = this.dateFinish.close.getTime() - currentDay.getTime();
    this.dateClose.daysLeft = Math.floor(differ / (1000 * 60 * 60 * 24));
    this.dateFinish.daysLeft = Math.floor(differFinish / (1000 * 60 * 60 * 24));
    this.dateClose.text = this.textDays(this.dateClose.daysLeft);
    this.dateFinish.text = this.textDays(this.dateFinish.daysLeft);
  }

  textDays(daysLeft: number) {
    switch (true) {
      case daysLeft > 1:
        return daysLeft + ' días';
      case daysLeft === 1:
        return daysLeft + ' día';
      case daysLeft === 0:
        return 'Hoy';
      case daysLeft < 0:
        return 'Finalizó';
      default:
        break;
    }
  }
}
